import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import avatar from 'flarum/common/helpers/avatar';
import username from 'flarum/common/helpers/username';
import humanTime from 'flarum/common/helpers/humanTime';
import { truncate, getPlainContent } from 'flarum/common/utils/string';

export const EXCERPT_LENGTH = 300;

/**
 * Plain-text excerpt of a post. The HTML is Flarum's own server-rendered
 * (sanitised) contentHtml, parsed with DOMParser (which never executes
 * scripts) and only ever output as a text node.
 */
export function excerpt(post) {
  const html = post.contentHtml() || '';
  const text = getPlainContent(html).replace(/\s+/g, ' ').trim();
  return truncate(text, EXCERPT_LENGTH);
}

export default class NwcTrackerItem extends Component {
  view() {
    const post = this.attrs.post;
    const user = post.user();
    const discussion = post.discussion();
    const url = app.route.post(post);
    const tags = (discussion && discussion.tags && discussion.tags()) || [];

    return (
      <article className="NwcTrackerItem">
        <div className="NwcTrackerItem-avatar">
          {user ? <Link href={app.route.user(user)}>{avatar(user)}</Link> : avatar(user)}
        </div>
        <div className="NwcTrackerItem-main">
          <header className="NwcTrackerItem-meta">
            <span className="NwcTrackerItem-author">
              {user ? <Link href={app.route.user(user)}>{username(user)}</Link> : username(user)}
            </span>
            <span className="NwcBadge">{app.translator.trans('mnm-nwc-tracker.forum.badge.label')}</span>
            <span className="NwcTrackerItem-time">
              <Link href={url}>{humanTime(post.createdAt())}</Link>
            </span>
          </header>
          <div className="NwcTrackerItem-context">
            <span className="NwcTrackerItem-in">{app.translator.trans('mnm-nwc-tracker.forum.feed.in_discussion')} </span>
            <Link className="NwcTrackerItem-discussion" href={url}>
              {discussion ? discussion.title() : ''}
            </Link>
            {tags.filter(Boolean).map((tag) => (
              <Link
                className="NwcTrackerItem-tag"
                href={app.route('tag', { tags: tag.slug() })}
                style={tag.color() ? { '--nwc-tag-color': tag.color() } : undefined}
              >
                {tag.name()}
              </Link>
            ))}
          </div>
          <Link className="NwcTrackerItem-excerpt" href={url}>
            {excerpt(post)}
          </Link>
          <div className="NwcTrackerItem-actions">
            <Link className="NwcTrackerItem-view" href={url}>
              {app.translator.trans('mnm-nwc-tracker.forum.feed.view_post')} »
            </Link>
          </div>
        </div>
      </article>
    );
  }
}
